// Reads a human-readable message off any thrown value.
//
// Supabase / PostgREST reject with PLAIN OBJECTS of shape
// `{ message, details, hint, code }` — they are NOT `Error` instances, and
// this repo re-throws them raw in ~256 places (`if (error) throw error;`
// across shared/services DAOs). So the natural-looking
//
//     e instanceof Error ? e.message : String(e)
//
// evaluates false for a real database error and renders the operator
// `String({message:"..."})` === "[object Object]", swallowing the actual
// message. Read the shape instead of testing the prototype.
//
// Returns `undefined` (not a generic string) so callers keep control of
// their own fallback copy: `errorText(e) ?? t("...")`.
export function errorText(e: unknown): string | undefined {
  if (typeof e === "object" && e !== null && "message" in e) {
    const m = (e as { message?: unknown }).message;
    if (typeof m === "string") return m;
  }
  return undefined;
}
